import { styled } from '@mui/material';

const StyledInfoBlockListItemWrap = styled('li')(() => ({
	display: 'flex',
	background: '#FFFFFFB2',
	borderRadius: '12px',
	justifyContent: 'space-between',
	alignItems: 'center',
	gap: '12px',
	padding: '16px 8px',
}));

export default StyledInfoBlockListItemWrap;
